import { render } from "./TextWithArrowButton.vue?vue&type=template&id=c2557ff4"
import script from "./TextWithArrowButton.vue?vue&type=script&lang=js"
export * from "./TextWithArrowButton.vue?vue&type=script&lang=js"

import "./TextWithArrowButton.vue?vue&type=style&index=0&id=c2557ff4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__